






























import Vue from 'vue';
import Component from 'vue-class-component';
import { FlashMessage as FlashMessageInterface } from '../store/index.d';

@Component({
  name: 'FlashMessage',
})
export default class FlashMessage extends Vue {
  get flashMessage(): FlashMessageInterface {
    return this.$store.getters.flashMessage;
  }

  get flashMessageText() {
    return this.flashMessage.message;
  }

  get flashMessageStatus() {
    return this.flashMessage.level;
  }

  get toastClass() {
    let extraClasses = '';

    if (this.flashMessageText) {
      extraClasses = 'fade show';
    }

    return `toast ${extraClasses}`;
  }

  onCloseClick() {
    this.$store.commit('setFlashMessage', [null, 'normal']);
  }
}
